module.exports = __webpack_public_path__ + "static/img/drilling12.e8446e07.png";